<template>
  <v-card>
    <v-card-title class="headline">
      <v-icon>edit</v-icon> Compensar permiso
      <v-spacer></v-spacer>
      {{
        horas_disponibles === null
          ? ""
          : `Tiene ${horas_disponibles} horas disponibles`
      }}
    </v-card-title>
    <v-form @submit.prevent="adicionarDetalle()" ref="form" lazy-validation>
      <v-card-text class="py-0">
        <v-container grid-list-md class="pa-0" style="min-width: 100%;">
          <v-layout>
            <v-flex md4>
              <p>
                <strong>Total horas a compensar:</strong>
                {{ debe_horas_compensacion }}
              </p>
            </v-flex>
          </v-layout>
          <!-- Cargado de archivos-->
          <p v-if="permiso.id_tipo_permiso == 96">
            <strong> Respaldo : </strong>{{ file.name }}
          </p>
          <!-- para adjuntos no obligatorios-->
          <v-layout v-if="permiso.id_tipo_permiso == 96">
            <v-flex xs12 md4>
              <input
                type="file"
                @change="handleFileUpload()"
                ref="file"
                accept="application/pdf"
                v
              />
              <p class="red--text body-1" v-if="errors.denied">
                *Formato no admitido por el sistema
              </p>
            </v-flex>
          </v-layout>
          <!-- Fecha compensacion -->
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                class="text-field-reducido-border"
                outline
                type="date"
                v-model="form.fecha_desde"
                label="Fecha"
                :rules="$validate(['required'])"
                required
                @input="verificaCompensacion()"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group
                v-model="form.tipo_dia"
                @change="verificaCompensacion()"
              >
                <!-- <v-flex>
                  <v-radio label="Mañana" value="1"></v-radio>
                </v-flex>  -->
                <v-flex>
                  <v-radio label="Tarde" value="2"></v-radio>
                </v-flex>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 md6>
              <v-radio-group
                v-model="form.horario"
                @change="verificaCompensacion()"
              >
                <!-- <v-radio label="Ingreso" value="1"></v-radio> -->
                <v-radio label="Salida" value="2"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 md6>
              <v-select
                class="text-field-reducido-border"
                outline
                value="hora"
                :items="rango_horarios"
                type="hour"
                item-value="hora"
                item-text="hora"
                label="Cantidad de horas"
                v-model="form.horas_compensa"
                autofocus
                :rules="$validate(['required'])"
                required
                @input="verificaCompensacion()"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 md6>
              <v-text-field
                class="text-field-reducido-border"
                outline
                type="time"
                label="Hora desde"
                v-model="hora_desde_calculada"
                disabled
              />
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                class="text-field-reducido-border"
                outline
                type="time"
                label="Hora hasta"
                v-model="hora_hasta_calculada"
                disabled
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="cargarCompensacion()">
                <v-icon>arrow_downward</v-icon>
                Registrar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-text>
        <h3><strong>Detalles compensación</strong></h3>
        <v-layout>
          <v-flex xs12>
            <v-data-table
              class="elevation-1 tabla-comprimida-light"
              :items="compensaciones"
              hide-actions
              :headers="headers"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">
                  {{ $moment(props.item.fecha).format("DD/MM/YYYY") }}
                </td>
                <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                <td class="text-xs-center">
                  {{ props.item.total_horas }}
                </td>
                <td class="text-xs-center">
                  <v-btn
                    color="error"
                    icon
                    title="Eliminar compensacion"
                    @click="borrarCompensacionDetalle(props.item.id)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout class="pa-2">
          <v-flex xs12>
            <h4>
              <strong
                >Total horas:
                {{ total_horas_compensacion.format("HH:mm") }}</strong
              >
            </h4>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pr-4">
        <v-spacer></v-spacer>

        <v-btn :to="`/permisos/usuario/${getPersonaId()}`" color="error">
          <v-icon>cancel</v-icon>CANCELAR
        </v-btn>
        <v-btn @click.native="save()" color="primary">
          <v-icon>cancel</v-icon>GUARDAR
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  props: ["item", "horas_compensacion", "ruta_ar", "estado_a"],

  async mounted() {
    if (this.file) {
      if (this.estado_archivo == 0) {
        this.errors.denied = false;
      } else {
        this.errors.denied = true;
      }
    } else {
      this.errors.denied = false;
      this.estado_archivo = null;
    }
    await this.diferenciaHoras();
    this.$bus.$on("actualizarHoraTolerancia", async () => {
      await this.diferenciaHoras();
    });
  },
  data() {
    return {
      permiso: this.item,
      //this.horas_compensacion
      debe_horas_compensacion: null,

      estado_archivo: this.estado_a,
      errors: {
        denied: false
      },
      file: this.ruta_ar,
      form: {},
      compensaciones: [],
      rango_horarios: [
        {
          hora: "00:30"
        },
        {
          hora: "01:00"
        },
        {
          hora: "01:30"
        },
        {
          hora: "02:00"
        },
        {
          hora: "02:30"
        },
        {
          hora: "03:00"
        },
        {
          hora: "03:30"
        },
        {
          hora: "04:00"
        },
        {
          hora: "04:30"
        },
        {
          hora: "05:00"
        },
        {
          hora: "05:30"
        }
      ],

      headers: [
        {
          text: "Fecha",
          align: "center",
          sortable: false
        },
        {
          text: "Hora desde",
          align: "center",
          sortable: false
        },
        {
          text: "Hora hasta",
          align: "center",
          sortable: false
        },
        {
          text: "Total Horas",
          align: "center",
          sortable: false
        },
        {
          text: "Acción",
          align: "center",
          sortable: false
        }
      ],
      permiso_detalles: [],
      permisoDetalle: [],
      horas_disponibles: null,
      hora_desde_calculada: "",
      hora_hasta_calculada: "",
      total_horas_calculada: "",
      mensaje_error: "",
      bandera_compensacion: false,
      correlativo_compensacion: 0,
      total_horas_compensacion: this.$moment().set({
        hour: 0,
        minutes: 0,
        seconds: 0
      })
    };
  },
  methods: {
    async diferenciaHoras() {
      try {
        if (this.permiso.hora_desde && this.permiso.hora_hasta) {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_calcula_diferencia_horas_funcionario(${this.getPersonaId()},'${
              this.permiso.hora_desde
            }','${this.permiso.hora_hasta}','${this.permiso.fecha_desde}')"){
                  respuesta
                }
              }
            `
          });
          respuesta =
            respuesta.runQuery.respuesta[0]
              .fn_calcula_diferencia_horas_funcionario;
          if (respuesta.split("|")[0] != "0") {
            this.debe_horas_compensacion = this.$moment(
              respuesta,
              "HH:mm"
            ).format("HH:mm");
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async verificaCompensacion() {
      try {
        this.hora_desde_calculada = "";
        this.hora_hasta_calculada = "";
        this.total_horas_calculad = "";
        if (
          this.form.fecha_desde &&
          this.form.tipo_dia &&
          this.form.horario &&
          this.form.horas_compensa &&
          this.permiso.fecha_desde &&
          this.permiso.hora_desde &&
          this.permiso.hora_hasta
        ) {
          let id_persona = this.getPersonaId();
          ///permiso 88 goce de haberes
          if (this.permiso.id_tipo_permiso == 88) {
            let respuesta = await this.$service.graphql({
              query: `
                  query{
                    runQuery(consulta:"select control.fn_obtine_rangos_compensacion(${id_persona},'${
                this.form.fecha_desde
              }',${parseInt(this.form.tipo_dia)},${parseInt(
                this.form.horario
              )},'${this.form.horas_compensa}','${this.permiso.fecha_desde}','${
                this.permiso.hora_desde
              }','${this.permiso.hora_hasta}')"){
                      respuesta
                    }
                  }
                `
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_obtine_rangos_compensacion;
            let horarios = respuesta.split("|");
            if (horarios[0] != "0") {
              this.hora_desde_calculada = horarios[1];
              this.hora_hasta_calculada = horarios[2];
              this.total_horas_calculada = horarios[3];
            } else {
              this.mensaje_error = horarios[1];
              this.$message.info(this.mensaje_error);
            }
          }
          ///permiso 96 tolerancia
          if (this.permiso.id_tipo_permiso == 96) {
            let respuesta = await this.$service.graphql({
              query: `
                  query{
                    runQuery(consulta:"select control.fn_obtine_rangos_compensacion_tolerancia(${id_persona},'${
                this.form.fecha_desde
              }',${parseInt(this.form.tipo_dia)},${parseInt(
                this.form.horario
              )},'${this.form.horas_compensa}','${this.permiso.fecha_desde}','${
                this.permiso.hora_desde
              }','${this.permiso.hora_hasta}')"){
                      respuesta
                    }
                  }
                `
            });
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_obtine_rangos_compensacion_tolerancia;
            let horarios = respuesta.split("|");
            if (horarios[0] != "0") {
              this.hora_desde_calculada = horarios[1];
              this.hora_hasta_calculada = horarios[2];
              this.total_horas_calculada = horarios[3];
            } else {
              this.mensaje_error = horarios[1];
              this.$message.info(this.mensaje_error);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    cargarCompensacion() {
      if (
        this.form.fecha_desde &&
        this.form.tipo_dia &&
        this.form.horario &&
        this.form.horas_compensa &&
        this.hora_desde_calculada &&
        this.hora_hasta_calculada &&
        this.total_horas_calculada
      ) {
        let compensacion_crear = {
          id: this.correlativo_compensacion,
          fecha: this.form.fecha_desde,
          hora_desde: this.hora_desde_calculada,
          hora_hasta: this.hora_hasta_calculada,
          total_horas: this.total_horas_calculada
        };
        this.compensaciones.push(compensacion_crear);
        this.correlativo_compensacion += 1;
        this.form.fecha_desde = "";
        this.form.tipo_dia = "";
        this.form.horario = "";
        this.form.horas_compensa = "";
        this.hora_desde_calculada = "";
        this.hora_hasta_calculada = "";
        this.total_horas_calculada = "";
        this.$message.success("Registro exitoso");
        this.total_horas_compensacion.add(compensacion_crear.total_horas);
      } else {
        if (this.mensaje_error) {
          this.$message.warning(this.mensaje_error);
        } else {
          this.$message.warning("Revise si lleno todos los campos requeridos");
        }
      }
    },
    visualizaCompensacion() {
      this.bandera_compensacion = true;
    },
    async verificarCompensacion() {
      try {
        let id_persona = this.getPersonaId();
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select control.fn_corresponde_compensacion(${id_persona},'${this.permiso.fecha_desde}','${this.permiso.hora_desde}','${this.permiso.hora_hasta}')"){
                  respuesta
                }
              }
            `
        });
        respuesta = respuesta.runQuery.respuesta[0].fn_corresponde_compensacion;
        respuesta = respuesta.split("|");
        if (respuesta[0] == "SI") {
          this.$message.info("Usted debe compensar horas");
        } else {
          //   this.mensaje_error = horarios[1];
          //   this.$message.info(this.mensaje_error);
        }
        console.log(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    borrarCompensacionDetalle(id) {
      this.$confirm("¿Esta seguro de eliminar el registro?", () => {
        let posicion;
        let compensaciones_aux = [];
        for (let index = 0; index < this.compensaciones.length; index++) {
          const element = this.compensaciones[index];
          if (element.id != id) {
            compensaciones_aux.push(element);
          } else {
            this.total_horas_compensacion.subtract(element.total_horas);
          }
        }
        this.compensaciones = compensaciones_aux;
      });
    },
    getPersonaId() {
      const user = this.$storage.get("user");
      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    getRuta() {
      let p = this.$route.path;
      const a = p.split("/");
      return a[3];
    },
    async verificarPermisosRango(
      fecha_desde,
      fecha_hasta,
      hora_desde,
      hora_hasta
    ) {
      //Funcion notifica que hay un permiso creado en el rango de fechas seleccionado
      // control.fn_muestra_permisos_funcionario(p_id_persona integer, p_fecha date)
      let existePermisos = false;
      let permisos = "¿Esta seguro guardar el permiso?";
      let permisos_consulta = "";
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select control.fn_permisos_por_funcionario(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}')"){
                  respuesta
                }
              }
            `
        });
        respuesta = respuesta.runQuery.respuesta[0].fn_permisos_por_funcionario;
        respuesta = respuesta.split("|");
        if (respuesta[0] == "1") {
          existePermisos = true;
          permisos_consulta +=
            "<br><strong>Usted tiene los siguientes permisos en las fechas u horarios solicitados:</strong><br>" +
            respuesta[1].replace(/#/g, "<br>");
        }
      } catch (error) {
        console.log(error);
      }
      console.log(permisos);
      if (existePermisos) {
        this.$alert("No puede crear el permiso" + permisos_consulta);
      }
      return [existePermisos, permisos + permisos_consulta];
    },
    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors.denied = false;
          this.estado_archivo = 0;
        } else {
          this.errors.denied = true;
          this.estado_archivo = 1;
        }
        this.file = file;
      }
    },
    //verifica que una vacacion aprobada no choque con el permiso:
    async verificaVacaciones(fecha_desde, fecha_hasta) {
      let existe_vacacion = false;
      let permisos_consulta = "";
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select vacaciones.fn_verifica_coincidencia_de_vacaciones_aprobadas(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}')"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_verifica_coincidencia_de_vacaciones_aprobadas;

        if (respuesta != "0") {
          existe_vacacion = true;
          permisos_consulta +=
            "<br><strong>Usted tiene la siguiente vacación aprobada en las fechas solicitadas:</strong><br>" +
            respuesta.replace(/#/g, "<br>");
          this.$message.warning(permisos_consulta);
        }
        return existe_vacacion;
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      if (
        this.$moment(this.total_horas_compensacion, "HH:mm").format("HH:mm") ==
        this.$moment(this.debe_horas_compensacion, "HH:mm").format("HH:mm")
      ) {
        //consulta si existe una vacacion aprobada en ese rango de fechas
        let verifica_vacacion = await this.verificaVacaciones(
          this.permiso.fecha_desde,
          this.permiso.fecha_desde
        );
        if (verifica_vacacion == true) {
          return;
        }
        //consulta si existe un permiso aprobado en ese rango de fechas
        let consulta = await this.verificarPermisosRango(
          this.permiso.fecha_desde,
          this.permiso.fecha_desde,
          this.permiso.hora_desde,
          this.permiso.hora_hasta
        );
        if (consulta[0] == true) {
          return;
        }
        this.$confirm(consulta[1], async () => {
          let id_permiso_creado;
          try {
            //guardar archivos:
            //validar que seas pdf
            if (this.file != "" && this.permiso.id_tipo_permiso == 96) {
              if (this.estado_archivo == 1) {
                this.$confirm("Formato no admitido por el sistema", () => {
                  this.file == "";
                  this.estado_archivo = 0;
                });
                // return this.errors;
              }
            }
            let ruta_ar = "";
            //obtener ruta
            if (this.file != "" && this.permiso.id_tipo_permiso == 96) {
              let formData = new FormData();
              formData.append("file", this.file);
              let res = await this.$http.post(
                process.env.API_URL + "public/upload",
                formData
              );
              ruta_ar = res.data;
            } else {
              if (this.permiso.id_tipo_permiso == 96) {
                ruta_ar = "";
                this.estado_archivo == 0;
              }
            }

            //Funcion para guardar el permiso
            let id_persona = this.getPersonaId();
            const user = this.$storage.get("user");
            let fecha_actual = this.$moment().format("YYYY-MM-DD");
            if (this.permiso.id_tipo_permiso == 88) {
              let respuesta = await this.$service.graphql({
                query: `
                  query{
                      runQuery(consulta:"select control.fn_registra_permiso_particular(${parseInt(
                        this.permiso.id_tipo_permiso
                      )},'',${id_persona},'${fecha_actual}',${user.id}, '','${
                  this.permiso.fecha_desde
                }','${this.permiso.fecha_desde}','${
                  this.permiso.hora_desde
                }','${this.permiso.hora_hasta}',${parseInt(
                  this.permiso.rol
                )})"){
                          respuesta
                      }
                    }
                  `
              });
              let respuesta2 =
                respuesta.runQuery.respuesta[0].fn_registra_permiso_particular;
              let resps = respuesta2.split("|");
              let correcto = resps[0];
              if (correcto === "1") {
                id_permiso_creado = parseInt(resps[2]);
                let esCorrecto = true;
                for (
                  let index = 0;
                  index < this.compensaciones.length;
                  index++
                ) {
                  const element = this.compensaciones[index];
                  let respuesta_comp = await this.$service.graphql({
                    query: `
                  query{
                      runQuery(consulta:"select control.fn_registra_compensacion(${id_permiso_creado},'${element.fecha}','${element.fecha}','${element.hora_desde}','${element.hora_hasta}',${user.id})"){
                          respuesta
                      }
                    }
                  `
                  });
                  let respuesta3 =
                    respuesta_comp.runQuery.respuesta[0]
                      .fn_registra_compensacion;
                  resps = respuesta3.split("|");
                  if (resps[0] == "0") {
                    this.$confirm(resps[1], () => {});
                    esCorrecto = false;
                    break;
                  }
                }
                if (esCorrecto) {
                  this.$confirm("Registro exitoso", () => {});
                  if (this.getRuta() != this.getPersonaId()) {
                    this.$router.push("/permisos/usuario/");
                  }
                  if (this.getRuta() == this.getPersonaId()) {
                    this.$router.push(
                      "/permisos/usuario/" + this.getPersonaId()
                    );
                  }
                }
              } else {
                this.$confirm(resps[1], () => {});
              }
            }
            //permiso TOLERANCIA:
            if (this.permiso.id_tipo_permiso == 96) {
              console.log("entro");
              let respuesta = await this.$service.graphql({
                query: `
                  query{
                          runQuery(consulta:"select control.fn_registra_tolerancia(${id_persona},'${fecha_actual}',${user.id}, '${this.permiso.fecha_desde}','${this.permiso.fecha_desde}','${this.permiso.hora_desde}','${this.permiso.hora_hasta}','${this.permiso.motivo}',1,'${ruta_ar}')"){
                              respuesta
                                }
                            }
                  `
              });
              let respuesta2 =
                respuesta.runQuery.respuesta[0].fn_registra_tolerancia;
              let resps = respuesta2.split("|");
              let correcto = resps[0];
              console.log(resps, "h885555");
              if (correcto === "1") {
                this.$message.success("Registro exitoso");
                id_permiso_creado = parseInt(resps[1]);

                let esCorrecto = true;
                for (
                  let index = 0;
                  index < this.compensaciones.length;
                  index++
                ) {
                  const element = this.compensaciones[index];
                  let respuesta_comp = await this.$service.graphql({
                    query: `
                  query{
                      runQuery(consulta:"select control.fn_registra_compensacion(${id_permiso_creado},'${element.fecha}','${element.fecha}','${element.hora_desde}','${element.hora_hasta}',${user.id})"){
                          respuesta
                      }
                    }
                  `
                  });
                  let respuesta3 =
                    respuesta_comp.runQuery.respuesta[0]
                      .fn_registra_compensacion;
                  resps = respuesta3.split("|");
                  if (resps[0] == "0") {
                    this.$confirm(resps[1], () => {});
                    esCorrecto = false;
                    break;
                  }
                }
                if (esCorrecto) {
                  this.$confirm("Registro exitoso", () => {});
                  if (this.getRuta() != this.getPersonaId()) {
                    this.$router.push("/permisos/usuario/");
                  }
                  if (this.getRuta() == this.getPersonaId()) {
                    this.$router.push(
                      "/permisos/usuario/" + this.getPersonaId()
                    );
                  }
                }
              } else {
                this.$confirm(resps[1], () => {});
              }
            }
          } catch (error) {
            console.log(error);
          }
        });
      } else {
        this.$message.warning(
          "Las horas de compensación no coinciden con las horas del permiso"
        );
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/permiso/components/Compensacion.vue